import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const KEY = "nx_session_id";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(KEY);
    if (!sid) {
      sid = "s_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      sessionStorage.setItem(KEY, sid);
    }
    return sid;
  } catch (err) {
    console.warn("analytics: sessionStorage unavailable, using anonymous id", err);
    return "s_anon_" + Date.now().toString(36);
  }
}

export function track(eventType, metadata = {}) {
  try {
    const payload = {
      event_type: eventType,
      path: window.location.pathname + window.location.search,
      session_id: getSessionId(),
      referrer: document.referrer || null,
      metadata,
    };
    // Fire-and-forget; never block UI or throw
    axios.post(`${API}/events`, payload).catch((err) => {
      console.warn("analytics: event dispatch failed", err?.message || err);
    });
  } catch (err) {
    console.warn("analytics: track failed", err);
  }
}

export function trackPageView() {
  track("page_view");
}

// Aliases for readability at call sites
export const trackRFQClick = (source) => track("rfq_cta_click", { source });
export const trackWhatsAppOpen = () => track("whatsapp_open");
export const trackWhatsAppSend = () => track("whatsapp_send");
export const trackDeckDownload = (source) => track("deck_download", { source });
export const trackRFQSubmit = (category) => track("rfq_submit", { category });
